module.exports = __webpack_public_path__ + "img/cn-select.47d05771.jpg";